(function($) {

    // functions 

    function form_labels() {
        jQuery(".gfield").each(function( index ) {
            if(jQuery(this).find('.ginput_container_checkbox').length > 0){
                jQuery(this).addClass('gfield_type_checkbox');
                return true;
            }
            if(jQuery(this).find('.ginput_container_radio').length > 0){
                jQuery(this).addClass('gfield_type_radio');
                return true;
            }
            var label = jQuery(this).find('.gfield_label');
            var input = jQuery(this).find('.ginput_container input , .ginput_container textarea');
            if ( input.val() !== "" ) { jQuery(label).addClass("active"); }
            jQuery(label).on( "click", function() {
                jQuery(input).focus();
            });
            jQuery(input).on( "focus", function() {
                jQuery(label).addClass("active");
            });
            jQuery(input).on( "focusout", function() {
                var value =  jQuery.trim( jQuery(this).val() );
                if ( value.length === 0 || jQuery(this).val() === '(___) ___-____' ) {
                    jQuery(label).removeClass("active");
                }
            });
        });
    }



    $(document).ready(function(){

        // document ready
        form_labels();

    });
    
    
    })(jQuery);